/**
 * Memory Storage Backend
 *
 * In-memory storage fallback when other storage mechanisms are unavailable.
 * Data is lost when the page is refreshed.
 */

import type { StorageBackend, StorageBackendOptions } from './types';

export class MemoryBackend implements StorageBackend {
  private storage = new Map<string, string>();

  get(key: string): string | null {
    return this.storage.get(key) ?? null;
  }

  set(key: string, value: string, _options?: StorageBackendOptions): void {
    this.storage.set(key, value);
  }

  remove(key: string): void {
    this.storage.delete(key);
  }

  clear(): void {
    this.storage.clear();
  }

  isSupported(): boolean {
    // Memory storage is always supported
    return true;
  }
}
